import { render, staticRenderFns } from "./ModalRoleEdit.vue?vue&type=template&id=81e98b90&scoped=true"
import script from "./ModalRoleEdit.vue?vue&type=script&lang=js"
export * from "./ModalRoleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalRoleEdit.vue?vue&type=style&index=0&id=81e98b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e98b90",
  null
  
)

export default component.exports